import { __assign, __extends } from "tslib";
import { omit } from '@antv/util';
import GroupComponent from '../abstract/group-component';
import { BAR_STYLE, FOREGROUND_STYLE, SLIDER_BAR_LINE_GAP } from './constant';
var Foreground = /** @class */ (function (_super) {
    __extends(Foreground, _super);
    function Foreground() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Foreground.prototype.getDefaultCfg = function () {
        var cfg = _super.prototype.getDefaultCfg.call(this);
        return __assign(__assign({}, cfg), { name: 'foreground', width: 100, height: 16, foregroundStyle: FOREGROUND_STYLE, barStyle: BAR_STYLE });
    };
    Foreground.prototype.renderInner = function (group) {
        var _this = this;
        var _a = this.cfg, x = _a.x, height = _a.height, width = _a.width, foregroundStyle = _a.foregroundStyle, barStyle = _a.barStyle;
        var brushRatio = foregroundStyle.brushRatio;
        // 上方移动区域
        this.addShape(group, {
            id: this.getElementId('foreground-scroll'),
            name: 'foreground-scroll',
            type: 'rect',
            attrs: __assign({ x: x, y: 0, width: width, height: height * (1 - brushRatio), cursor: 'move' }, omit(foregroundStyle, ['stroke'])),
        });
        // 下方brush区域
        this.addShape(group, {
            id: this.getElementId('foreground-brush'),
            name: 'foreground-brush',
            type: 'rect',
            attrs: __assign({ x: x, y: height * (1 - brushRatio), width: width, height: height * brushRatio, cursor: 'crosshair' }, omit(foregroundStyle, ['stroke'])),
        });
        // 上方Bar区域
        var barGroup = this.addGroup(group, {
            id: this.getElementId('foreground-bar'),
            name: 'foreground-bar',
        });
        // 外层矩形
        this.addShape(barGroup, {
            id: this.getElementId('foreground-bar-rect'),
            name: 'foreground-bar-rect',
            type: 'rect',
            attrs: __assign({ x: x, y: -barStyle.height, width: width, height: barStyle.height, cursor: 'move' }, omit(barStyle, ['stroke'])),
        });
        // 三条小竖线
        var centerX = width / 2 + x;
        var leftX = centerX - SLIDER_BAR_LINE_GAP;
        var rightX = centerX + SLIDER_BAR_LINE_GAP;
        var y1 = -(1 / 4) * barStyle.height;
        var y2 = -(3 / 4) * barStyle.height;
        var publicAttrs = __assign({ y1: y1,
            y2: y2 }, barStyle);
        [leftX, centerX, rightX].forEach(function (x) {
            _this.drawBarLine(group, x, publicAttrs);
        });
        // 背景边框
        this.addShape(group, {
            id: this.getElementId('foreground-border'),
            name: 'foreground-border',
            type: 'rect',
            attrs: {
                x: x,
                y: 0,
                width: width,
                height: height,
                stroke: foregroundStyle === null || foregroundStyle === void 0 ? void 0 : foregroundStyle.stroke,
                opacity: foregroundStyle === null || foregroundStyle === void 0 ? void 0 : foregroundStyle.strokeOpacity,
                lineWidth: foregroundStyle === null || foregroundStyle === void 0 ? void 0 : foregroundStyle.lineWidth,
            },
        });
    };
    Foreground.prototype.drawBarLine = function (group, x, attrs) {
        this.addShape(group, {
            id: this.getElementId("line-" + x),
            name: "foreground-line",
            type: 'line',
            attrs: __assign({ x1: x, x2: x }, attrs),
        });
    };
    Foreground.prototype.initEvent = function () {
        this.bindEvents();
    };
    Foreground.prototype.bindEvents = function () {
        var _this = this;
        var _a = this.get('barStyle'), highLightFill = _a.highLightFill, fill = _a.fill;
        var barRectShape = this.get('group').findById(this.getElementId('foreground-bar-rect'));
        this.get('group').on('foreground-bar:mouseenter', function () {
            barRectShape.attr('fill', highLightFill);
            _this.draw();
        });
        this.get('group').on('foreground-scroll:mouseenter', function () {
            barRectShape.attr('fill', highLightFill);
            _this.draw();
        });
        this.get('group').on('foreground-bar:mouseleave', function () {
            barRectShape.attr('fill', fill);
            _this.draw();
        });
        this.get('group').on('foreground-scroll:mouseleave', function () {
            barRectShape.attr('fill', fill);
            _this.draw();
        });
    };
    Foreground.prototype.draw = function () {
        var canvas = this.get('container').get('canvas');
        if (canvas) {
            canvas.draw();
        }
    };
    return Foreground;
}(GroupComponent));
export { Foreground };
//# sourceMappingURL=foreground.js.map